import React from "react";
import ComplianceReporting from "components/newDesign/compliance/ComplianceReporting";

const ComplianceReportsPage = () => {
  return <ComplianceReporting />;
};

export default ComplianceReportsPage;
